import { memo } from 'react'
import { NavLink } from 'react-router-dom'

import customConfig from 'customConfig'
import Button from '../../../components/shared/button/Button'
import { ACCOUNT_URL } from '../../../constants/navigation'
import { BWLink, BWPanelContent } from '../../../libs/qb-brand-web-components'

const OverviewEnterCodeWrapper = ({ t, ...restProps }) => {
  return (
    <BWPanelContent>
      <NavLink to={ACCOUNT_URL}>
        <Button label={t('brand:user.overview-account')} />
      </NavLink>
      <BWLink
        label={t(customConfig.overviewEnterRewardCodeLabel)}
        {...restProps}
      />
    </BWPanelContent>
  )
}

export default memo(OverviewEnterCodeWrapper)
